import { FC } from 'react';
import { styled } from '@mui/material/styles';
import { Children, memo } from 'react';
import {
  AppBar as MuiAppBar,
  Toolbar,
  useMediaQuery,
  Theme,
  Box,
  Typography,
  Button,
} from '@mui/material';
import { AppBarProps, HideOnScroll } from 'react-admin';
import { AppBarMenu } from './AppBarMenu';

import { useTranslate,  AppBarClasses} from 'react-admin';
import { AppBarToolbar } from './AppBarToolbar';
import { AppUserMenu } from './AppUserMenu';
import { AppBarTitle } from './AppBarTitle';

export const CustomAppBar: FC<AppBarProps> = memo(props => {
  const {
    alwaysOn,
    children,
    className,
    color = 'secondary',
    container: Container = alwaysOn ? 'div' : HideOnScroll,
    ...rest
  } = props;

  const isXSmall = useMediaQuery<Theme>(theme =>
    theme.breakpoints.down('sm')
  );

  return (
    <Container className={className}>
      <StyledAppBar
        className={AppBarClasses.appBar}
        color={color}
        {...rest}
      >
        <Toolbar
          disableGutters
          variant={isXSmall ? 'regular' : 'dense'}
          className={AppBarClasses.toolbar}
        >
          <AppBarTitle />
          {children}
          <AppBarMenu />
          <Box sx={{ flexGrow: 1 }} />
          <AppBarToolbar />
          <AppUserMenu />
        </Toolbar>
      </StyledAppBar>
    </Container>
  );
});

const PREFIX = 'RaAppBar';

const StyledAppBar = styled(MuiAppBar, {
  name: PREFIX,
  overridesResolver: (props, styles) => styles.root,
})(({ theme }) => ({
  [`& .${AppBarClasses.toolbar}`]: {
    padding: `0 ${theme.spacing(1)}`,
    [theme.breakpoints.down('md')]: {
      minHeight: theme.spacing(6),
    },
  },
  [`& .${AppBarClasses.menuButton}`]: {
    marginRight: '0.2em',
  },
  [`& .${AppBarClasses.title}`]: {},
}));

